import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import SigninForm from "./pages/login";
import Home from "./pages/home";
import CompleteTask from "./components/home/actionButton/completeTask.js";
import SimpleMode from "./components/home/actionButton/simpleMode.js";
import DriverPage from "./components/home/actionButton/DriverPage.js";
import Keyboard from "./components/header/help/keyboard";
import Support from "./components/header/help/support";
import AddAccount from "./components/header/admin/addAccount";
import CasesCancelledReportView from "./components/dashboard/reports/CaseMangement/CasesCancelledReportView.js";
import PrintWorkTicketSticker from "./components/dashboard/cases/newCase/case_id/actionButton/PrintWorkTicketSticker.js";
import PrintWorkTicket from "./components/dashboard/cases/newCase/case_id/actionButton/PrintWorkTicket.js";
import User from "./components/header/admin/myAccount/user";
import Calender from "./components/header/hiraDentalLab/calender";
import File from "./components/header/hiraDentalLab/files/fileSetting";
import Addnewfile from "./components/header/hiraDentalLab/files/addNewfile";
import LabSetting from "./components/header/hiraDentalLab/labSetting";
import Users from "./components/header/hiraDentalLab/users/users";
import AddNewUser from "./components/header/hiraDentalLab/users/addNewUser";
import DetailTabs from "./components/header/hiraDentalLab/labDetails/tabs";
import Overview from "./components/dashboard/cases/overview";
import AccountDetails from "./components/dashboard/cases/newCase/accountDetails";
import NewPlanEstimate from "./components/dashboard/cases/newPlanEstimate/newPlanEstimate";
import NewCasePickup from "./components/dashboard/cases/casePickup/newCasePickup";
import CasesOpened from "./components/dashboard/cases/byMonth/casesOpened";
import CaseShip from "./components/dashboard/cases/ship/caseShip";
import CreatShipment from "./components/dashboard/cases/shipment/creatShipment.js";
import OpenTryInCases from "./components/dashboard/cases/tryIns/openTryIns.js";
import CasesOnHold from "./components/dashboard/cases/onHold/casesOnHold.js";
import ToOutsource from "./components/dashboard/cases/outsource/toOutsource.js";
import CaseEstimates from "./components/dashboard/cases/planEstimate/caseEstimates.js";
import OpenCases from "./components/dashboard/cases/openCases/openCases.js";
import UndeliverableCases from "./components/dashboard/cases/undeliarableCases/undelivarableCases.js";
import Addaccountsales from "./components/dashboard/reports/Sales/Addaccountsale.js";
import ProtectedRoute, {
  ProtectedRouteWithPermission,
} from "./components/ProtectedRoute.js";
import PublicRoute from "./components/PublicRoute.js";
import { AuthProvider } from "./components/login/AuthProvider.js";
import PasswordReset from "./components/login/Reset.js";
import ResetPasswordConfirm from "./components/login/resetPasswirdConfirm.js";
import SettingOverview from "./components/dashboard/settings/overview.js";
import SearchAddPage from "./components/dashboard/settings/accounts/searchAddPage.js";
import AccountTable from "./components/dashboard/settings/accounts/accountsTable.js";
import AddContactButton from "./components/dashboard/settings/accounts/tabs/addContactButton.js";
import EditContactButton from "./components/dashboard/settings/accounts/tabs/editContactButton.js";
import TabsWorking from "./components/dashboard/settings/accounts/tabs/tabsWorking.js";
import FinanceOwerview from "./components/dashboard/finances/financeOverview.js";
import Posting from "./components/dashboard/finances/posting/posting.js";
import Statement from "./components/dashboard/finances/statement/statements.js";
import CaseSetting from "./components/dashboard/settings/caseSetting/caseSetting.js";
import RunStatements from "./components/dashboard/finances/statement/runStatement.js";
import PromotionOverview from "./components/dashboard/promotions/promotionOverview.js";
import DDXWebsites from "./components/dashboard/promotions/websites/website.js";
import DDXAdd from "./components/dashboard/promotions/ads/ddxAdd.js";
import AddButton from "./components/dashboard/promotions/ads/addButton.js";
import Coupon from "./components/dashboard/promotions/coupons/coupon.js";
import AddCoupon from "./components/dashboard/promotions/coupons/addCoupon.js";
import Widgets from "./components/dashboard/promotions/widgets/widgets.js";
import DDXAccount from "./components/dashboard/promotions/ddxAccount/ddxAccount.js";
import Case from "./components/dashboard/cases/newCase/case_id/case";
import EditUser from "./components/header/admin/EditUser/editUser.js";
import EditAuthentication from "./components/header/admin/EditUser/editauthentication.js";
import PatientRecord from "./components/dashboard/cases/PatientRecord.js";
import InvoiceDetail from "./components/dashboard/cases/newCase/invoiceDetails.js";
import AddLabProcedureReportTable from "./components/dashboard/settings/caseSetting/Tabs/procedures/labprocedure/AddLabProcedure.js";
import EditInvoice from "./components/dashboard/cases/newCase/EditInvoice.js";
import PermissionGroups from "./components/dashboard/settings/permissionGroup/permissionGroups.js";
import AddPermissionGroup from "./components/dashboard/settings/permissionGroup/addPermissionGroup.js";
import Reports from "./components/dashboard/reports/reports.js";
import Addsalereport from "./components/dashboard/reports/Sales/Addsale.js";
import Addinvoiceitem from "./components/dashboard/reports/Sales/Addinvoice.js";
import PartnerLab from "./components/dashboard/partnerLab.js";
import Reprintbutton from "./components/dashboard/finances/statement/reprintbutton.js";
import ReprintStatements from "./components/dashboard/finances/statement/reprintStatement.js";
import Summary from "./components/dashboard/reports/Finances/Summary.js";
import RunDateRangeStatement from "./components/dashboard/finances/statement/RunDateRangeStatement.js";
import EditPermission from "./components/header/admin/EditUser/editPermission.js";
import AddCategory from "./components/dashboard/settings/caseSetting/Tabs/procedures/AddCategory .js";
import CasesArrive from "./components/dashboard/cases/arrive/casesArrive .js";
import BarcodeList from "./components/dashboard/reports/CaseMangement/BarcodeList.js";
import BatchPrintWorkTicketsForm from "./components/dashboard/reports/CaseMangement/batchprintworkticketsform.js";
import Addshipping from "./components/dashboard/reports/CaseMangement/Addshipping.js";
import CaseFiles from "./components/dashboard/reports/CaseMangement/caseFile.js";
import EditAttributePrices from "./components/dashboard/settings/caseSetting/Tabs/procedures/labprocedure/EditAttributePrices.js";
import EditPriceLists from "./components/dashboard/settings/caseSetting/Tabs/procedures/labprocedure/EditPriceLists.js";
import PriceListTable from "./components/dashboard/settings/caseSetting/Tabs/procedures/labprocedure/PriceListTable.js";
import ProcedureQuickCodes from "./components/dashboard/settings/caseSetting/Tabs/procedures/labprocedure/ProcedureQuickCodes.js";
import ProcedureGroups from "./components/dashboard/settings/caseSetting/Tabs/procedures/labprocedure/ProcedureGroups.js";
import AddProcedureGroup from "./components/dashboard/settings/caseSetting/Tabs/procedures/labprocedure/AddProcedureGroup.js";
import MultiEdit from "./components/dashboard/settings/caseSetting/Tabs/procedures/labprocedure/MultiEdit.js";
import AssignPrice from "./components/dashboard/settings/accounts/AssignPrice.js";
import AssignProcedure from "./components/dashboard/settings/accounts/AssignProcedure.js";
import AssignShippingService from "./components/dashboard/settings/accounts/AssignShippingService.js";
import AssignAccountTags from "./components/dashboard/settings/accounts/AssignAccountTags.js";
import AccountQuickCodes from "./components/dashboard/settings/accounts/AccountQuickCodes.js";
import AddNewAccountDefaults from "./components/dashboard/settings/accounts/AddNewAccountDefaults.js";
import NewAccountDefaults from "./components/dashboard/settings/accounts/NewAccountDefaults.js";
import Reportresult from "./components/dashboard/reports/CaseMangement/Reportresult.js";
import ReportParameters from "./components/dashboard/reports/CaseMangement/NewCases.js";
import AddShippingType from "./components/dashboard/settings/caseSetting/Tabs/general/shipping/AddShippingType.js";
import ShippingEdit from "./components/dashboard/settings/caseSetting/Tabs/general/shipping/ShippingEdit.js";
import ShippingTypes from "./components/dashboard/settings/caseSetting/Tabs/general/shipping/ShippingTypes.js";
import AssignAccounts from "./components/dashboard/settings/caseSetting/Tabs/general/shipping/AssignShipping.js";
import Chart from "./components/chartbot/Chart.js";
import PreferencesTab from "./components/header/hiraDentalLab/labDetails/preferences.js";
import { CurrencyProvider } from "./context/currencyContext.js";
import StatementEmail from "./components/header/hiraDentalLab/labDetails/pin/StatementEmail.jsx";
import ReReprint from "./components/dashboard/finances/statement/rereprint.js";
import PreviewStatement from "./components/dashboard/finances/statement/preview.js";

// ========== CASE SETTING TAB PAGES ==========
import NextCase from "./components/dashboard/settings/caseSetting/Tabs/general/nextCase/nextCase.js";
import LabProcedure from "./components/dashboard/settings/caseSetting/Tabs/procedures/labprocedure/LabProcedure";
import DisplayCategories from "./components/dashboard/settings/caseSetting/Tabs/procedures/DisplayCate";
import Departments from "./components/dashboard/settings/caseSetting/Tabs/procedures/Departments/Departments.js";

// ========== SOCKET + TOAST ==========
import { SocketProvider, useSocket } from "./context/SocketContext";
import ToastNotification from "./components/ToastNotification.jsx";
import OutsourceCaseDetails from "./components/dashboard/cases/outsource/outsourceCaseDetails.js";
import OutsourceReceived from "./components/dashboard/cases/outsource/OutsourceReceived.js";
import ManualsPage from "./pages/manualPage.js";
import OutsourceInvoiceDetail from "./components/dashboard/cases/outsource/OutsourceInvoiceDetail.js";
import OutsourcePosting from "./components/outsourcefinances/OutsourcePosting.js";
import AddnextCase from "./components/dashboard/settings/caseSetting/Tabs/general/nextCase/AddnextCase.js";
import Editnextcase from "./components/dashboard/settings/caseSetting/Tabs/general/nextCase/Editnextcase.js";
import OutsourcePrintWorkTicket from "./components/dashboard/cases/newCase/case_id/actionButton/OutsourcePrintWorkTicket.js";
import OutsourcePrintWorkTicketSticker from "./components/dashboard/cases/newCase/case_id/actionButton/OutsourcePrintWorkTicketSticker.js";

// ========== GLOBAL UPLOAD MANAGER ==========
import { UploadManagerProvider } from "./context/UploadManagerContext";
import EditCategory from "./components/dashboard/settings/caseSetting/Tabs/procedures/EditCategory.js";
import PrintBadges from "./components/header/hiraDentalLab/users/PrintBadges.js";
import ScanningAssigning from "./components/header/hiraDentalLab/users/ScanningAssigning.js";
import Tasks from "./components/dashboard/settings/caseSetting/Tabs/procedures/Tasks/Tasks.js";
import EditDepartment from "./components/dashboard/settings/caseSetting/Tabs/procedures/Departments/editdepartment.js";
import AddDepartment from "./components/dashboard/settings/caseSetting/Tabs/procedures/Departments/AddDepartment.js";

// ========== COMMUNICATION PAGES ==========
import ChatGroups from "./pages/ChatGroups";
import MyMentions from "./pages/MyMentions";
import Notifications from "./pages/Notifications";

// ========== APP CONTENT WRAPPER ==========
const AppContent = () => {
  const { toastNotification, clearToast } = useSocket();

  return (
    <>
      <BrowserRouter>
        <Routes>
          {/* ========== PUBLIC ROUTES ========== */}
          <Route element={<PublicRoute />}>
            <Route path="/" element={<SigninForm />} />
            <Route path="/reset" element={<PasswordReset />} />
            <Route
              path="/reset-password/:userId"
              element={<ResetPasswordConfirm />}
            />
          </Route>

          {/* ========== PROTECTED ROUTES ========== */}
          <Route element={<ProtectedRoute />}>
            {/* COMMUNICATION — visible to all logged-in users */}
            <Route path="/chat" element={<ChatGroups />} />
            <Route path="/mentions" element={<MyMentions />} />
            <Route path="/notifications" element={<Notifications />} />

            <Route
              path="/home"
              element={
                <ProtectedRouteWithPermission path="/home" element={Home} />
              }
            />
            <Route
              path="/keyboard"
              element={
                <ProtectedRouteWithPermission
                  path="/keyboard"
                  element={Keyboard}
                />
              }
            />
            <Route path="/PrintBadges" element={<PrintBadges />} />
            <Route
              path="/support"
              element={
                <ProtectedRouteWithPermission
                  path="/support"
                  element={Support}
                />
              }
            />
            <Route
              path="/completeTasks"
              element={
                <ProtectedRouteWithPermission
                  path="/completeTasks"
                  element={CompleteTask}
                />
              }
            />
            <Route path="/report-result" element={<Reportresult />} />
            <Route path="/ScanningAssigning" element={<ScanningAssigning />} />
<Route path="/caseSetting/tasks" element={<Tasks />} />
<Route path="/add-task" element={<Tasks />} />
<Route path="/edit-task" element={<Tasks />} />
<Route path="/case-tasks" element={<Tasks />} />
<Route path="/progress-stages" element={<Tasks />} />
<Route path="/task-scanning-assigning" element={<Tasks />} />
<Route path="/edit-department/:id" element={<EditDepartment />} />
<Route path="/add-department" element={<AddDepartment />} />
            <Route
              path="/simpleMode"
              element={
                <ProtectedRouteWithPermission
                  path="/simpleMode"
                  element={SimpleMode}
                />
              }
            />
            <Route
              path="/driverPage"
              element={
                <ProtectedRouteWithPermission
                  path="/driverPage"
                  element={DriverPage}
                />
              }
            />
            <Route
              path="/user"
              element={
                <ProtectedRouteWithPermission path="/user" element={User} />
              }
            />
            <Route
              path="/addAccount"
              element={
                <ProtectedRouteWithPermission
                  path="/addAccount"
                  element={AddAccount}
                />
              }
            />
            <Route
              path="/editUser/:userId"
              element={
                <ProtectedRouteWithPermission
                  path="/editUser/:userId"
                  element={EditUser}
                />
              }
            />
            <Route
              path="/editauthentication"
              element={
                <ProtectedRouteWithPermission
                  path="/editauthentication"
                  element={EditAuthentication}
                />
              }
            />
            <Route
              path="/newCases"
              element={
                <ProtectedRouteWithPermission
                  path="/newCases"
                  element={ReportParameters}
                />
              }
            />
            <Route
              path="/calender"
              element={
                <ProtectedRouteWithPermission
                  path="/calender"
                  element={Calender}
                />
              }
            />
            <Route
              path="/file"
              element={
                <ProtectedRouteWithPermission path="/file" element={File} />
              }
            />
            <Route
              path="/addNewfile"
              element={
                <ProtectedRouteWithPermission
                  path="/addNewfile"
                  element={Addnewfile}
                />
              }
            />
            <Route
              path="/labSetting"
              element={
                <ProtectedRouteWithPermission
                  path="/labSetting"
                  element={LabSetting}
                />
              }
            />
            <Route
              path="/users"
              element={
                <ProtectedRouteWithPermission path="/users" element={Users} />
              }
            />
            <Route
              path="/AddNewUser"
              element={
                <ProtectedRouteWithPermission
                  path="/AddNewUser"
                  element={AddNewUser}
                />
              }
            />
            <Route
              path="/tabs"
              element={
                <ProtectedRouteWithPermission
                  path="/tabs"
                  element={DetailTabs}
                />
              }
            />
            <Route
              path="/partner-labs"
              element={
                <ProtectedRouteWithPermission
                  path="/partner-labs"
                  element={PartnerLab}
                />
              }
            />
            <Route
              path="/overview"
              element={
                <ProtectedRouteWithPermission
                  path="/overview"
                  element={Overview}
                />
              }
            />
            <Route
              path="/accountDetails"
              element={
                <ProtectedRouteWithPermission
                  path="/accountDetails"
                  element={AccountDetails}
                />
              }
            />
            <Route
              path="/accountDetails/:caseId"
              element={
                <ProtectedRouteWithPermission
                  path="/accountDetails/:caseId"
                  element={AccountDetails}
                />
              }
            />
            <Route
              path="/newPlanEstimate"
              element={
                <ProtectedRouteWithPermission
                  path="/newPlanEstimate"
                  element={NewPlanEstimate}
                />
              }
            />
            <Route
              path="/newCasePickup"
              element={
                <ProtectedRouteWithPermission
                  path="/newCasePickup"
                  element={NewCasePickup}
                />
              }
            />
            <Route
              path="/casesOpened"
              element={
                <ProtectedRouteWithPermission
                  path="/casesOpened"
                  element={CasesOpened}
                />
              }
            />
            <Route
              path="/casesArrive"
              element={
                <ProtectedRouteWithPermission
                  path="/casesArrive"
                  element={CasesArrive}
                />
              }
            />
            <Route
              path="/caseship"
              element={
                <ProtectedRouteWithPermission
                  path="/caseship"
                  element={CaseShip}
                />
              }
            />
            <Route
              path="/creatShipment"
              element={
                <ProtectedRouteWithPermission
                  path="/creatShipment"
                  element={CreatShipment}
                />
              }
            />
            <Route
              path="/openTryInCases"
              element={
                <ProtectedRouteWithPermission
                  path="/openTryInCases"
                  element={OpenTryInCases}
                />
              }
            />
            <Route
              path="/casesOnHold"
              element={
                <ProtectedRouteWithPermission
                  path="/casesOnHold"
                  element={CasesOnHold}
                />
              }
            />
            <Route
              path="/toOutsource"
              element={
                <ProtectedRouteWithPermission
                  path="/toOutsource"
                  element={ToOutsource}
                />
              }
            />
            <Route
              path="/caseEstimates"
              element={
                <ProtectedRouteWithPermission
                  path="/caseEstimates"
                  element={CaseEstimates}
                />
              }
            />
            <Route
              path="/account/:accountId/contacts/edit/:contactId"
              element={
                <ProtectedRouteWithPermission
                  path="/account/:accountId/contacts/edit/:contactId"
                  element={EditContactButton}
                />
              }
            />
            <Route
              path="/openCases"
              element={
                <ProtectedRouteWithPermission
                  path="/openCases"
                  element={OpenCases}
                />
              }
            />
            <Route
              path="/undelivarableCases"
              element={
                <ProtectedRouteWithPermission
                  path="/undelivarableCases"
                  element={UndeliverableCases}
                />
              }
            />
            <Route
              path="/sticker/:caseId"
              element={
                <ProtectedRouteWithPermission
                  path="/sticker/:caseId"
                  element={PrintWorkTicketSticker}
                />
              }
            />
            <Route
              path="/workticket/:caseId"
              element={
                <ProtectedRouteWithPermission
                  path="/workticket/:caseId"
                  element={PrintWorkTicket}
                />
              }
            />
            <Route
              path="/outsource-print-work-ticket/:caseNumber"
              element={
                <ProtectedRouteWithPermission
                  path="/outsource-print-work-ticket/:caseNumber"
                  element={OutsourcePrintWorkTicket}
                />
              }
            />
            <Route
              path="/outsource-sticker/:caseNumber"
              element={
                <ProtectedRouteWithPermission
                  path="/outsource-sticker/:caseNumber"
                  element={OutsourcePrintWorkTicketSticker}
                />
              }
            />
            <Route
              path="/patientDetails"
              element={
                <ProtectedRouteWithPermission
                  path="/patientDetails"
                  element={AccountDetails}
                />
              }
            />
            <Route
              path="/patientrecords"
              element={
                <ProtectedRouteWithPermission
                  path="/patientrecords"
                  element={PatientRecord}
                />
              }
            />
            <Route
              path="/case/:caseId"
              element={
                <ProtectedRouteWithPermission
                  path="/case/:caseId"
                  element={Case}
                />
              }
            />
            <Route
              path="/searchAddPage"
              element={
                <ProtectedRouteWithPermission
                  path="/searchAddPage"
                  element={SearchAddPage}
                />
              }
            />
            <Route
              path="/accountTable"
              element={
                <ProtectedRouteWithPermission
                  path="/accountTable"
                  element={AccountTable}
                />
              }
            />
            <Route
              path="/account/:accountId/contacts/add"
              element={
                <ProtectedRouteWithPermission
                  path="/account/:accountId/contacts/add"
                  element={AddContactButton}
                />
              }
            />
            <Route
              path="/tabsWorking/:accountId"
              element={
                <ProtectedRouteWithPermission
                  path="/tabsWorking/:accountId"
                  element={TabsWorking}
                />
              }
            />
            <Route
              path="/settings-overview"
              element={
                <ProtectedRouteWithPermission
                  path="/settings-overview"
                  element={SettingOverview}
                />
              }
            />
            <Route
              path="/financeOwerview"
              element={
                <ProtectedRouteWithPermission
                  path="/financeOwerview"
                  element={FinanceOwerview}
                />
              }
            />
            <Route
              path="/posting"
              element={
                <ProtectedRouteWithPermission
                  path="/posting"
                  element={Posting}
                />
              }
            />
            <Route
              path="/statement"
              element={
                <ProtectedRouteWithPermission
                  path="/statement"
                  element={Statement}
                />
              }
            />

            {/* ========== CASE SETTING (nested) ========== */}
            <Route
              path="/caseSetting"
              element={
                <ProtectedRouteWithPermission
                  path="/caseSetting"
                  element={CaseSetting}
                />
              }
            >
              <Route path="general" element={<></>} />
              <Route path="procedures" element={<></>} />
              <Route path="next-case-types" element={<NextCase />} />
              <Route path="shipping-types" element={<ShippingTypes />} />
              <Route path="lab-procedures" element={<LabProcedure />} />
              <Route path="display-categories" element={<DisplayCategories />} />
              {/* ✅ NEW: Departments sub-tab */}
              <Route path="departments" element={<Departments />} />
              <Route path="*" element={<Navigate to="/caseSetting" replace />} />
            </Route>

            <Route
              path="/promtoionOverview"
              element={
                <ProtectedRouteWithPermission
                  path="/promtoionOverview"
                  element={PromotionOverview}
                />
              }
            />
            <Route
              path="/website"
              element={
                <ProtectedRouteWithPermission
                  path="/website"
                  element={DDXWebsites}
                />
              }
            />
            <Route
              path="/ddxAdd"
              element={
                <ProtectedRouteWithPermission path="/ddxAdd" element={DDXAdd} />
              }
            />
            <Route
              path="/addButton"
              element={
                <ProtectedRouteWithPermission
                  path="/addButton"
                  element={AddButton}
                />
              }
            />
            <Route
              path="/coupon"
              element={
                <ProtectedRouteWithPermission path="/coupon" element={Coupon} />
              }
            />
            <Route
              path="/addcoupon"
              element={
                <ProtectedRouteWithPermission
                  path="/addcoupon"
                  element={AddCoupon}
                />
              }
            />
            <Route
              path="/widgets"
              element={
                <ProtectedRouteWithPermission
                  path="/widgets"
                  element={Widgets}
                />
              }
            />
            <Route
              path="/ddxAccount"
              element={
                <ProtectedRouteWithPermission
                  path="/ddxAccount"
                  element={DDXAccount}
                />
              }
            />
            <Route
              path="/invoices/:invoiceNumber"
              element={
                <ProtectedRouteWithPermission
                  path="/invoices/:invoiceNumber"
                  element={InvoiceDetail}
                />
              }
            />
            <Route
              path="/patientrecords/:id"
              element={
                <ProtectedRouteWithPermission
                  path="/patientrecords/:id"
                  element={PatientRecord}
                />
              }
            />
            <Route
              path="/Addlabprocedure"
              element={
                <ProtectedRouteWithPermission
                  path="/Addlabprocedure"
                  element={AddLabProcedureReportTable}
                />
              }
            />
            <Route
              path="/add-category"
              element={
                <ProtectedRouteWithPermission
                  path="/add-category"
                  element={AddCategory}
                />
              }
            />
            <Route
              path="/edit-category/:id"
              element={
                <ProtectedRouteWithPermission
                  path="/edit-category/:id"
                  element={EditCategory}
                />
              }
            />
            <Route
              path="/invoices/:invoiceNumber/edit"
              element={
                <ProtectedRouteWithPermission
                  path="/invoices/:invoiceNumber/edit"
                  element={EditInvoice}
                />
              }
            />
            <Route
              path="/PermissionGroups"
              element={
                <ProtectedRouteWithPermission
                  path="/PermissionGroups"
                  element={PermissionGroups}
                />
              }
            />
            <Route
              path="/AddPermissionGroup"
              element={
                <ProtectedRouteWithPermission
                  path="/AddPermissionGroup"
                  element={AddPermissionGroup}
                />
              }
            />
            <Route
              path="/reports"
              element={
                <ProtectedRouteWithPermission
                  path="/reports"
                  element={Reports}
                />
              }
            />
            <Route
              path="/Addsale"
              element={
                <ProtectedRouteWithPermission
                  path="/Addsale"
                  element={Addsalereport}
                />
              }
            />
            <Route
              path="/reprint-statement"
              element={
                <ProtectedRouteWithPermission
                  path="/reprint-statement"
                  element={Reprintbutton}
                />
              }
            />
            <Route
              path="/reprint-Statements"
              element={
                <ProtectedRouteWithPermission
                  path="/reprint-Statements"
                  element={ReprintStatements}
                />
              }
            />
            <Route
              path="/statements/by-date/:runDate"
              element={
                <ProtectedRouteWithPermission
                  path="/statements/by-date/:runDate"
                  element={Summary}
                />
              }
            />
            <Route
              path="/runStatements"
              element={
                <ProtectedRouteWithPermission
                  path="/runStatements"
                  element={RunStatements}
                />
              }
            />
            <Route
              path="/run-date-range-statement"
              element={
                <ProtectedRouteWithPermission
                  path="/run-date-range-statement"
                  element={RunDateRangeStatement}
                />
              }
            />
            <Route
              path="/Addinvoice"
              element={
                <ProtectedRouteWithPermission
                  path="/Addinvoice"
                  element={Addinvoiceitem}
                />
              }
            />
            <Route
              path="/Addaccountsale"
              element={
                <ProtectedRouteWithPermission
                  path="/Addaccountsale"
                  element={Addaccountsales}
                />
              }
            />
            <Route
              path="BatchPrintWorkTicketsForm"
              element={<BatchPrintWorkTicketsForm />}
            />
            <Route path="/barcodes" element={<BarcodeList />} />
            <Route
              path="/edit-permissions/:userId"
              element={
                <ProtectedRouteWithPermission
                  path="/edit-permissions/:userId"
                  element={EditPermission}
                />
              }
            />
            <Route
              path="/rereprint-statement"
              element={
                <ProtectedRouteWithPermission
                  path="/rereprint-statement"
                  element={ReReprint}
                />
              }
            />
            <Route
              path="/preview-statement/:previewId"
              element={
                <ProtectedRouteWithPermission
                  path="/preview-statement/:previewId"
                  element={PreviewStatement}
                />
              }
            />
            <Route
              path="/outsource-case/:caseNumber"
              element={
                <ProtectedRouteWithPermission
                  path="/outsource-case/:caseNumber"
                  element={OutsourceCaseDetails}
                />
              }
            />
            <Route
              path="/outsource-received"
              element={
                <ProtectedRouteWithPermission
                  path="/outsource-received"
                  element={OutsourceReceived}
                />
              }
            />
            <Route
              path="/manuals"
              element={
                <ProtectedRouteWithPermission
                  path="/manuals"
                  element={ManualsPage}
                />
              }
            />
            <Route
              path="/outsource-invoice/:invoiceNumber"
              element={
                <ProtectedRouteWithPermission
                  path="/outsource-invoice/:invoiceNumber"
                  element={OutsourceInvoiceDetail}
                />
              }
            />
            <Route
              path="/AddnextCase"
              element={
                <ProtectedRouteWithPermission
                  path="/AddnextCase"
                  element={AddnextCase}
                />
              }
            />
            <Route
              path="/Editnextcase/:id"
              element={
                <ProtectedRouteWithPermission
                  path="/Editnextcase/:id"
                  element={Editnextcase}
                />
              }
            />
            <Route
              path="/outsource-postings"
              element={
                <ProtectedRouteWithPermission
                  path="/outsource-postings"
                  element={OutsourcePosting}
                />
              }
            />
            <Route
              path="/cases-cancelled-report"
              element={<CasesCancelledReportView />}
            />
            <Route path="/addshipping" element={<Addshipping />} />
            <Route path="/AddCaseFile" element={<CaseFiles />} />
            <Route path="/edit-attribute-price" index element={<EditAttributePrices />} />
            <Route path="/edit-price-lists" index element={<EditPriceLists />} />
            <Route path="/price-list-table" index element={<PriceListTable />} />
            <Route path="/procedure-quick-codes" index element={<ProcedureQuickCodes />} />
            <Route path="/procedure-groups" element={<ProcedureGroups />} />
            <Route path="/add-procedure-group" element={<AddProcedureGroup />} />
            <Route path="/multi-edit" element={<MultiEdit />} />
            <Route path="/assign" element={<AssignPrice />} />
            <Route path="/assign-procedure" element={<AssignProcedure />} />
            <Route path="/assign-shipping" element={<AssignShippingService />} />
            <Route path="/assign-tags" element={<AssignAccountTags />} />
            <Route path="/account-quick" element={<AccountQuickCodes />} />
            <Route path="/account-default" element={<NewAccountDefaults />} />
            <Route path="/add-account-default" element={<AddNewAccountDefaults />} />
            <Route path="/AddShippingType" element={<AddShippingType />} />
            <Route path="/shipping-edit/:id" element={<ShippingEdit />} />
            <Route path="/shipping-types" element={<ShippingTypes />} />
            <Route path="/assign-accounts/:id" element={<AssignAccounts />} />
            <Route path="/statement-email/lab/:labId" element={<StatementEmail />} />
            <Route
              path="/preferences"
              element={
                <ProtectedRouteWithPermission
                  path="/preferences"
                  element={PreferencesTab}
                />
              }
            />
          </Route>
        </Routes>

        <div className="chatbot-container no-print">
          <Chart />
        </div>
      </BrowserRouter>

      {toastNotification && (
        <ToastNotification
          notification={toastNotification}
          onClose={clearToast}
        />
      )}
    </>
  );
};

// ========== MAIN APP COMPONENT ==========
const App = () => {
  return (
    <AuthProvider>
      <CurrencyProvider>
        <SocketProvider>
          <UploadManagerProvider>
            <AppContent />
          </UploadManagerProvider>
        </SocketProvider>
      </CurrencyProvider>
    </AuthProvider>
  );
};

export default App;